import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';

import ReactTableGT2A from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import Button from '../common/form/button';
import SPButton from '../common/form/spButton';
import Content from '../common/template/content';
import { toastr } from 'react-redux-toastr';
import { fetchTickets, fetchInteracoes, addInteracao, updateTicket } from './ticketSuporteActions';
import TicketSuporteForm from './ticketSuporteForm';
import { filtrarPorTexto, premiumBadge } from '../manutencao/manutencaoListUtils';
import ProcessingOverlay from '../common/components/processingOverlay';
import './ticketSuporte.css';

const STATUS_OPCOES = [
  { value: 'TODOS', label: 'Todos' },
  { value: 'ABERTO', label: 'Abertos' },
  { value: 'EM_ANDAMENTO', label: 'Em andamento' },
  { value: 'FINALIZADO', label: 'Finalizados' },
];

const STATUS_LABELS = {
  ABERTO: 'Aberto',
  EM_ANDAMENTO: 'Em andamento',
  FINALIZADO: 'Finalizado',
};

const STATUS_BADGE_CLASS = {
  ABERTO: 'os-badge--amber',
  EM_ANDAMENTO: 'os-badge--blue',
  FINALIZADO: 'os-badge--green',
};

const CTRL_BADGE_CLASS = {
  ONLINE: 'os-badge--green',
  OFFLINE: 'os-badge--red',
};

function formatarData(valor) {
  if (!valor) return '—';
  return new Date(valor).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function iniciais(nome) {
  if (!nome) return '?';
  return nome
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(parte => parte[0])
    .join('')
    .toUpperCase();
}

class TicketSuporteList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      editingTicket: null,
      loading: false,
      statusFilter: 'TODOS',
      filtroBusca: '',
      pageAtual: 0,
      showInteractionsModal: false,
      currentTicketForInteractions: null,
      newInteractionText: '',
      editingTicketStatus: '',
      originalTicketStatus: '',
      isSavingStatus: false,
    };
    this._isMounted = false;
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleStatusFilterChange = this.handleStatusFilterChange.bind(this);
    this.handleBuscaChange = this.handleBuscaChange.bind(this);
    this.loadTickets = this.loadTickets.bind(this);
    this.handleShowInteractionsModal = this.handleShowInteractionsModal.bind(this);
    this.handleCloseInteractionsModal = this.handleCloseInteractionsModal.bind(this);
    this.handleNewInteractionChange = this.handleNewInteractionChange.bind(this);
    this.handleAddNewInteraction = this.handleAddNewInteraction.bind(this);
    this.handleEditingTicketStatusChange = this.handleEditingTicketStatusChange.bind(this);
    this.handleSaveTicketStatus = this.handleSaveTicketStatus.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadTickets();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadTickets() {
    if (!this._isMounted) return;
    this.setState({ loading: true });

    const { statusFilter } = this.state;
    const params = statusFilter && statusFilter !== 'TODOS' ? { status: statusFilter } : {};

    this.props
      .fetchTickets(params)
      .catch(error => {
        if (this._isMounted) {
          toastr.error('Erro', 'Não foi possível carregar os tickets.');
          console.error('Erro ao buscar tickets:', error);
        }
      })
      .finally(() => {
        if (this._isMounted) {
          this.setState({ loading: false });
        }
      });
  }

  handleStatusFilterChange(event) {
    this.setState({ statusFilter: event.target.value, pageAtual: 0 }, this.loadTickets);
  }

  handleBuscaChange(event) {
    this.setState({ filtroBusca: event.target.value, pageAtual: 0 });
  }

  handlePageChange(page) {
    this.setState({ pageAtual: page });
  }

  handleShowModal(ticket = null) {
    this.setState({ showModal: true, editingTicket: ticket });
  }

  handleCloseModal() {
    this.setState({ showModal: false, editingTicket: null });
    this.loadTickets();
  }

  handleShowInteractionsModal(ticket) {
    this.setState({
      showInteractionsModal: true,
      currentTicketForInteractions: ticket,
      newInteractionText: '',
      editingTicketStatus: ticket.status,
      originalTicketStatus: ticket.status,
      isSavingStatus: false,
    });
    this.props.fetchInteracoes(ticket.id);
  }

  handleCloseInteractionsModal() {
    this.setState({ showInteractionsModal: false, currentTicketForInteractions: null });
  }

  handleNewInteractionChange(event) {
    this.setState({ newInteractionText: event.target.value });
  }

  handleAddNewInteraction() {
    const { currentTicketForInteractions, newInteractionText } = this.state;
    if (!newInteractionText.trim()) {
      toastr.warning('Atenção', 'O texto da interação não pode estar vazio.');
      return;
    }

    this.props
      .addInteracao(currentTicketForInteractions.id, { texto_interacao: newInteractionText.trim() })
      .then(() => {
        if (this._isMounted) {
          this.setState({ newInteractionText: '' });
        }
      })
      .catch(error => {
        console.error('Falha ao adicionar interação (componente):', error);
      });
  }

  handleEditingTicketStatusChange(event) {
    this.setState({ editingTicketStatus: event.target.value });
  }

  handleSaveTicketStatus() {
    const { currentTicketForInteractions, editingTicketStatus } = this.state;
    if (!currentTicketForInteractions || !editingTicketStatus) return;

    this.setState({ isSavingStatus: true });

    this.props
      .updateTicket({ ...currentTicketForInteractions, status: editingTicketStatus })
      .then(() => {
        toastr.success('Sucesso', 'Status do ticket atualizado!');
        if (this._isMounted) {
          this.setState(prev => ({
            originalTicketStatus: editingTicketStatus,
            isSavingStatus: false,
            currentTicketForInteractions: {
              ...prev.currentTicketForInteractions,
              status: editingTicketStatus,
            },
          }));
        }
      })
      .catch(error => {
        toastr.error('Erro', 'Falha ao atualizar o status do ticket.');
        console.error('Erro ao salvar status do ticket:', error);
        if (this._isMounted) {
          this.setState({ isSavingStatus: false });
        }
      });
  }

  renderStatusBadge(status) {
    const key = String(status || '').toUpperCase();
    return premiumBadge(STATUS_LABELS[key] || status || '—', STATUS_BADGE_CLASS[key] || 'os-badge--gray');
  }

  renderControladorBadge(statusCtrl) {
    const key = String(statusCtrl || '').toUpperCase();
    const label = statusCtrl || 'N/A';
    return premiumBadge(label, CTRL_BADGE_CLASS[key] || 'os-badge--gray');
  }

  renderFiltros() {
    const { statusFilter, filtroBusca } = this.state;

    return (
      <div className="os-list-filters-bar">
        <div className="os-list-filter-group">
          <label className="os-list-filter-label" htmlFor="ticket-list-filtro-status">
            Status
          </label>
          <select
            id="ticket-list-filtro-status"
            className="form-control os-list-filter-select"
            value={statusFilter}
            onChange={this.handleStatusFilterChange}
          >
            {STATUS_OPCOES.map(opcao => (
              <option key={opcao.value} value={opcao.value}>
                {opcao.label}
              </option>
            ))}
          </select>
        </div>
        <div className="os-list-filter-group os-list-filter-group--search">
          <label className="os-list-filter-label" htmlFor="ticket-list-filtro-busca">
            Buscar
          </label>
          <input
            id="ticket-list-filtro-busca"
            type="search"
            className="form-control os-list-filter-input"
            value={filtroBusca}
            onChange={this.handleBuscaChange}
            placeholder="Título, notificação, usuário..."
          />
        </div>
      </div>
    );
  }

  renderInteractionsModal() {
    const {
      showInteractionsModal,
      currentTicketForInteractions,
      newInteractionText,
      editingTicketStatus,
      originalTicketStatus,
      isSavingStatus,
    } = this.state;
    const {
      interacoesDoTicketAtual,
      interacoesLoading,
      interacoesError,
      currentTicketInteractionsAdding,
      currentTicketInteractionsAddError,
    } = this.props;

    if (!currentTicketForInteractions) return null;

    const interacoesOrdenadas = [...(interacoesDoTicketAtual || [])].sort(
      (a, b) => new Date(b.data_interacao) - new Date(a.data_interacao),
    );

    return (
      <Modal
        show={showInteractionsModal}
        onHide={this.handleCloseInteractionsModal}
        backdrop="static"
        keyboard={false}
        dialogClassName="ticket-interacoes-modal-dialog"
      >
        <div className="os-excel-modal-shell">
          <div className="os-excel-modal-header">
            <div className="os-excel-modal-header-main">
              <div className="os-excel-modal-header-icon">
                <i className="fa fa-comments" />
              </div>
              <div>
                <h4>Ticket #{currentTicketForInteractions.id}</h4>
                <p>{currentTicketForInteractions.titulo || 'Sem título'}</p>
              </div>
            </div>
            <button
              type="button"
              className="os-excel-modal-close"
              onClick={this.handleCloseInteractionsModal}
              aria-label="Fechar"
            >
              <i className="fa fa-times" />
            </button>
          </div>

          <div className="os-excel-modal-body ticket-interacoes-modal-body">
            <div className="ticket-interacoes-resumo">
              <div className="ticket-interacoes-resumo-grid">
                <div>
                  <span className="ticket-interacoes-label">Controlador</span>
                  <strong>
                    {(currentTicketForInteractions.controlador_numero !== null && currentTicketForInteractions.controlador_numero !== undefined)
                      ? `Ctrl ${String(currentTicketForInteractions.controlador_numero).padStart(2, '0')}`
                      : currentTicketForInteractions.controlador_id || '—'}
                  </strong>
                </div>
                <div>
                  <span className="ticket-interacoes-label">Grupo físico</span>
                  <strong>{currentTicketForInteractions.grupo_fisico_id || '—'}</strong>
                </div>
                <div>
                  <span className="ticket-interacoes-label">Notificação</span>
                  <strong>{currentTicketForInteractions.controlador_erro_id || '—'}</strong>
                </div>
                <div>
                  <span className="ticket-interacoes-label">Aberto por</span>
                  <strong>{currentTicketForInteractions.nome_usuario_abertura || '—'}</strong>
                </div>
                <div>
                  <span className="ticket-interacoes-label">Abertura</span>
                  <strong>{formatarData(currentTicketForInteractions.data_abertura)}</strong>
                </div>
                <div className="ticket-interacoes-status-field">
                  <span className="ticket-interacoes-label">Status</span>
                  <div className="ticket-interacoes-status-row">
                    <select
                      className="form-control ticket-interacoes-status-select"
                      value={editingTicketStatus}
                      onChange={this.handleEditingTicketStatusChange}
                    >
                      <option value="ABERTO">Aberto</option>
                      <option value="EM_ANDAMENTO">Em andamento</option>
                      <option value="FINALIZADO">Finalizado</option>
                    </select>
                    {originalTicketStatus !== editingTicketStatus && (
                      <button
                        type="button"
                        className="btn btn-primary ticket-interacoes-status-save"
                        onClick={this.handleSaveTicketStatus}
                        disabled={isSavingStatus}
                      >
                        {isSavingStatus ? <i className="fa fa-spinner fa-spin" /> : <i className="fa fa-save" />}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="ticket-interacoes-descricao">
              <h5>
                <i className="fa fa-align-left" /> Descrição original
              </h5>
              <p>{currentTicketForInteractions.descricao || 'Nenhuma descrição fornecida.'}</p>
            </div>

            <div className="ticket-interacoes-composer">
              <h5>
                <i className="fa fa-plus-circle" /> Nova interação
              </h5>
              <textarea
                className="form-control ticket-interacoes-textarea"
                rows={3}
                value={newInteractionText}
                onChange={this.handleNewInteractionChange}
                placeholder="Digite sua observação ou resposta..."
                disabled={currentTicketInteractionsAdding}
              />
              {currentTicketInteractionsAddError && (
                <p className="ticket-interacoes-erro">Falha ao adicionar interação. Tente novamente.</p>
              )}
            </div>

            <div className="ticket-interacoes-historico">
              <h5>
                <i className="fa fa-history" /> Histórico
              </h5>
              {interacoesLoading && (
                <p className="ticket-interacoes-loading">
                  <i className="fa fa-spinner fa-spin" /> Carregando interações...
                </p>
              )}
              {interacoesError && <p className="ticket-interacoes-erro">Erro ao carregar interações.</p>}
              {!interacoesLoading && !interacoesError && interacoesOrdenadas.length === 0 && (
                <div className="ticket-interacoes-empty">
                  <i className="fa fa-comment-slash" />
                  <span>Nenhuma interação registrada ainda.</span>
                </div>
              )}
              {!interacoesLoading && !interacoesError && interacoesOrdenadas.length > 0 && (
                <div className="ticket-interacoes-timeline">
                  {interacoesOrdenadas.map(interacao => (
                    <div
                      className={`ticket-interacao-item${interacao.privado ? ' is-private' : ''}`}
                      key={interacao.id}
                    >
                      <div className="ticket-interacao-avatar">{iniciais(interacao.nome_usuario)}</div>
                      <div className="ticket-interacao-body">
                        <div className="ticket-interacao-top">
                          <strong>{interacao.nome_usuario || 'Usuário'}</strong>
                          <span>{formatarData(interacao.data_interacao)}</span>
                        </div>
                        <p>{interacao.texto_interacao}</p>
                        {interacao.privado ? (
                          <span className="ticket-interacao-private-badge">
                            <i className="fa fa-lock" /> Privado
                          </span>
                        ) : null}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="os-excel-modal-footer">
            <Button
              type="button"
              className="default"
              icon="close"
              label="Fechar"
              onClick={this.handleCloseInteractionsModal}
            />
            <button
              type="button"
              className="btn btn-primary os-excel-modal-action-btn"
              onClick={this.handleAddNewInteraction}
              disabled={
                !newInteractionText.trim() || interacoesLoading || currentTicketInteractionsAdding
              }
            >
              {currentTicketInteractionsAdding ? (
                <>
                  <i className="fa fa-spinner fa-spin" /> Adicionando...
                </>
              ) : (
                <>
                  <i className="fa fa-plus" /> Adicionar interação
                </>
              )}
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  render() {
    const { config } = this.props;

    if (!config || !config.modulo_tickets) {
      return <Redirect to="/" />;
    }

    const { showModal, editingTicket, loading, filtroBusca, pageAtual } = this.state;
    const { tickets } = this.props;

    const ticketsFiltrados = filtrarPorTexto(
      tickets || [],
      ['titulo', 'mensagem_erro', 'nome_usuario_abertura', 'controlador_numero', 'grupo_fisico_id'],
      filtroBusca,
    );

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div className="os-actions-cell">
            <div className="os-actions-group">
              <SPButton
                type="button"
                className="info btn-sm"
                icon="comments"
                data-title="Interações"
                onClick={() => this.handleShowInteractionsModal(row.original)}
              />
            </div>
          </div>
        ),
        className: 'column_icon',
        width: 64,
        resizable: false,
        sortable: false,
        filterable: false,
      },
      {
        Header: 'Título',
        accessor: 'titulo',
        minWidth: 180,
        className: 'column_grid manutencao-col-texto',
        filterable: false,
        Cell: row => <span className="os-cell-ellipsis">{row.value || '—'}</span>,
      },
      {
        Header: 'Ctrl',
        accessor: 'controlador_numero',
        width: 72,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row =>
          (row.value !== null && row.value !== undefined) ? (
            <span className="os-cell-ctrl">{String(row.value).padStart(2, '0')}</span>
          ) : (
            <span className="os-cell-muted">—</span>
          ),
      },
      {
        Header: 'Grupo',
        accessor: 'grupo_fisico_id',
        width: 80,
        className: 'column_grid column_center',
        filterable: false,
      },
      {
        Header: 'Notificação',
        accessor: 'mensagem_erro',
        minWidth: 160,
        className: 'column_grid manutencao-col-texto',
        filterable: false,
        Cell: row => <span className="os-cell-ellipsis">{row.value || '—'}</span>,
      },
      {
        Header: 'Status',
        accessor: 'status',
        width: 120,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => this.renderStatusBadge(row.value),
      },
      {
        Header: 'Controlador',
        accessor: 'situacao_atual_controlador',
        width: 110,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => this.renderControladorBadge(row.value),
      },
      {
        Header: 'Aberto por',
        accessor: 'nome_usuario_abertura',
        width: 130,
        className: 'column_grid manutencao-col-texto',
        filterable: false,
        Cell: row => <span className="os-cell-ellipsis">{row.value || '—'}</span>,
      },
      {
        Header: 'Atualização',
        accessor: 'data_ultima_atualizacao',
        width: 130,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => <span className="os-cell-data">{formatarData(row.value)}</span>,
      },
    ];

    return (
      <Content>
        <div className="ticket-suporte-premium-page">
          <div className="ticket-suporte-page-header">
            <div>
              <h2>
                <i className="fa fa-ticket-alt" /> Tickets de Suporte
              </h2>
              <p>Gerenciamento de chamados do cliente para a SSAT</p>
            </div>
            <Button
              type="button"
              className="primary ticket-suporte-novo-btn"
              icon="plus"
              label="Novo chamado"
              onClick={() => this.handleShowModal()}
            />
          </div>

          <div className="manutencao-premium-list ticket-suporte-premium-list table-container">
            <ProcessingOverlay
              show={loading}
              message={
                <>
                  Carregando tickets de suporte...
                  <small>Aguarde enquanto os chamados são consultados.</small>
                </>
              }
              tagline="Tickets de Suporte"
            />

            <div className="os-list-top-panel">
              <p className="os-list-summary">{`${ticketsFiltrados.length} ticket(s)`}</p>
              {this.renderFiltros()}
            </div>
            <PremiumTableShell summary="" hideToolbar tableMinWidth={0}>
              <ReactTableGT2A
                data={ticketsFiltrados}
                columns={columns}
                defaultPageSize={15}
                showPagination
                filterable={false}
                loading={false}
                onPageChange={this.handlePageChange}
                page={pageAtual}
                minRows={0}
                noDataText="Nenhum ticket encontrado"
                className="-striped -highlight"
              />
            </PremiumTableShell>
          </div>

          <TicketSuporteForm show={showModal} onHide={this.handleCloseModal} ticket={editingTicket} />
          {this.renderInteractionsModal()}
        </div>
      </Content>
    );
  }
}

const mapStateToProps = state => ({
  config: state.auth.config,
  tickets: state.ticketSuporte.list,
  interacoesDoTicketAtual: state.ticketSuporte.currentTicketInteractions.data,
  interacoesLoading: state.ticketSuporte.currentTicketInteractions.loading,
  interacoesError: state.ticketSuporte.currentTicketInteractions.error,
  currentTicketInteractionsAdding: state.ticketSuporte.currentTicketInteractions.adding,
  currentTicketInteractionsAddError: state.ticketSuporte.currentTicketInteractions.addError,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ fetchTickets, fetchInteracoes, addInteracao, updateTicket }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TicketSuporteList);
